import { AgentResponse, AgentResponseData, DataFrom, RequestParams } from './misc';

type TokenAgentResponse = AgentResponse<AgentResponseData<string>>;

export class AuthCloudAPI {
    static getJwtToken() {
        return new RequestParams<DataFrom<TokenAgentResponse>>(['auth-cloud']);
    }
}
